import { useTutorial } from './context';
import { TutorialHighlightKey } from '../interfaces';

/**
 * Returns whether the given highlight target is the one currently active in
 * the running tutorial — intended to drive a `PulsingBorder`'s `active` prop.
 *
 * @param key - Highlight target to check.
 */
export const useTutorialHighlight = (key: TutorialHighlightKey): boolean => {
  const { activeHighlightTarget } = useTutorial();

  return activeHighlightTarget === key;
};
